// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1Dd3B","content":"Consent_content__2f6WV","footer":"Consent_footer__23RFw"};